import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useScale } from '../../../hooks/useScale';
import { useColors } from '../../../hooks/useColors';
import theme from '../../../common/theme';

const SetTimerModalStyles = () => {
  const { scale } = useScale();
  const { colors } = useColors();

  return useMemo(
    () =>
      StyleSheet.create({
        background: {
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.colors.modalBg,
        },
        container: {
          padding: scale(30),
          overflow: 'hidden',
          borderRadius: theme.radius.s,
          width: scale(340),
          backgroundColor: colors.popupBg,
          rowGap: scale(20),
        },
        title: {
          color: colors.text,
          fontSize: scale(16),
          lineHeight: scale(20),
          paddingLeft: scale(4),
          fontFamily: theme.fonts.medium,
        },
        inputs: {
          width: '100%',
          rowGap: scale(20),
          alignSelf: 'center',
        },
        inputContainer: {
          width: '100%',
          borderRadius: theme.radius.s,
          paddingTop: scale(6),
        },
        actions: {
          width: '100%',
          alignSelf: 'stretch',
          rowGap: scale(10),
        },
      }),
    [colors, scale],
  );
};

export default SetTimerModalStyles;
